// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltipComparison_tooltip__jIG2t","tooltip__item":"tooltipComparison_tooltip__item__doC2z","tooltip__name":"tooltipComparison_tooltip__name__nFPv4"};